const VWO_NEXTGEN_HOMEPAGE_EXPERIMENT = "NextGenHomePageUpdatedV18";
const VWO_NEXTGEN_PRODUCT_CARDS_EXPERIMENT = "NextgenProductCardsV2";
const VWO_CSAT_NPS_EXPERIMENT = "CSAT_HomeScreen_Widget_PWA";
const VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME =
  "next_gen_home_ab_experiment_v18";

export const vwoKeys = {
  [VWO_NEXTGEN_HOMEPAGE_EXPERIMENT]: {
    stage: "27e963cdd992519bb07d5b42643477f8",
    prod: "a418d918594728e8f328d33580294c41",
  },
  [VWO_NEXTGEN_PRODUCT_CARDS_EXPERIMENT]: {
    stage: "ab7c724fa85bfd2adf03c01f5b741761",
    prod: "0b9090f7a5bfa899fa40690c4dd964f2",
  },
  [VWO_CSAT_NPS_EXPERIMENT]: {
    stage: 'aef47809d07113306022e77f255ba0ba',
    prod: '2904f068cab69fc9b2ba8a73cb9fccb6'
  }
};

export const currentExperiments = [
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_CSAT_NPS_EXPERIMENT
];

export const VWO_NEXTGEN_EXPERIMENT_VARIANTS = {
  CONTROL: "nextgen_control",
  VARIANT_A: "nextgen_variant_a",
  VARIANT_B: "nextgen_variant_b",
  VARIANT_C: "nextgen_variant_c",
  VARIANT_D: "nextgen_variant_d",
  VARIANT_E: "nextgen_variant_e",
  VARIANT_F: "nextgen_variant_f",
  VARIANT_G: "nextgen_variant_g",
  VARIANT_H: "nextgen_variant_h",
  VARIANT_I: "nextgen_variant_i",
  VARIANT_J: "nextgen_variant_j",
  VARIANT_K: "nextgen_variant_k",
  VARIANT_L: "nextgen_variant_l",
  VARIANT_M: "nextgen_variant_m",
  VARIANT_N: "nextgen_variant_n",
  VARIANT_O: "nextgen_variant_o",
  VARIANT_P: "nextgen_variant_p",
  VARIANT_Q: "nextgen_variant_q",
  VARIANT_R: "nextgen_variant_r",
  VARIANT_S: "nextgen_variant_s",
  VARIANT_T: "nextgen_variant_t",
  VARIANT_V: "nextgen_variant_v",
  VARIANT_U: "nextgen_variant_u",
  VARIANT_W: "nextgen_variant_w",
  VARIANT_X: "nextgen_variant_x",
  VARIANT_Y: "nextgen_variant_y",
  VARIANT_Z: "nextgen_variant_z",
  VARIANT_ZA: "nextgen_variant_za",
};

export const VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY={
  CONTROL: "store-anchor",
  VARIANT_S: "store-anchor",
  VARIANT_N: "store-n",
  VARIANT_O: "store-o",
  VARIANT_P: "store-p",
  VARIANT_U: "landing",
  VARIANT_W: "landing",
  VARIANT_X: "landing",
  VARIANT_Y: "landing",
};

export const VWO_CSAT_NPS_EXPERIMENT_VARIANTS = {
  CONTROL: 'Control',
  CSAT_NPS_VARIANT: 'HomeScreenFeedbackWidget'
};

export {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME,
  VWO_CSAT_NPS_EXPERIMENT
};

export const vwoAccountId = 551982;
